const ROUTER_PATH = {
	index: '/dashboard/porto',
	login: '/login',
	resetPassword: '/reset-password',
	dashboard: '/dashboard',
	portofolio: '/dashboard/porto',
	userPortofolio: '/dashboard/user-porto',
	transactionHistory: '/dashboard/transaction-history',
	marketplace: '/marketplace/list',
	bulkMarketplaceSummaryList: '/bulk-list',
	privy: '/privy',
	afterFundingPage: '/fundingStatus',
    afterWithdrawPage: '/withdrawStatus',
	deposit: '/deposit'
};

export default ROUTER_PATH;
